"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const ModuleItemFilter_vue_1 = __importDefault(require("./ModuleItemFilter.vue"));
const ColonyDescription_1 = require("@/common/colonies/ColonyDescription");
const AllColonies_1 = require("@/common/colonies/AllColonies");
const ClientColonyManifest_1 = require("@/client/colonies/ClientColonyManifest");
const OFFICIAL_COLONIES = [...AllColonies_1.OFFICIAL_COLONY_NAMES].sort();
const COMMUNITY_COLONIES = [...AllColonies_1.COMMUNITY_COLONY_NAMES].sort();
const PATHFINDERS_COLONIES = [...AllColonies_1.PATHFINDERS_COLONY_NAMES].sort();
const GROUPS = [
    { key: 'colonies', label: 'Official' },
    { key: 'community', label: 'Community' },
    { key: 'pathfinders', label: 'Pathfinders' },
];
const ITEMS_BY_GROUP = {
    colonies: OFFICIAL_COLONIES,
    community: COMMUNITY_COLONIES,
    pathfinders: PATHFINDERS_COLONIES,
};
exports.default = (0, vue_1.defineComponent)({
    name: 'ColoniesFilter',
    components: { ModuleItemFilter: ModuleItemFilter_vue_1.default },
    emits: ['colonies-list-changed', 'close'],
    props: {
        expansions: { type: Object, required: true },
        selected: { type: Array, required: true },
    },
    data() {
        const initialSelected = this.selected.length > 0 ? [...this.selected] : [
            ...OFFICIAL_COLONIES,
            ...this.expansions.community ? COMMUNITY_COLONIES : [],
            ...this.expansions.pathfinders ? PATHFINDERS_COLONIES : [],
        ];
        return { initialSelected };
    },
    computed: {
        GROUPS() {
            return GROUPS;
        },
        ITEMS_BY_GROUP() {
            return ITEMS_BY_GROUP;
        },
        COLONY_DESCRIPTIONS() {
            return ColonyDescription_1.COLONY_DESCRIPTIONS;
        },
    },
    methods: {
        compatibility(name) {
            return (0, ClientColonyManifest_1.getColony)(name)?.expansion;
        },
    },
});
